/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TranscriptionGetResponse } from '../models/TranscriptionGetResponse';
import type { TranscriptionListResponse } from '../models/TranscriptionListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class V2CallsTranscriptionsService {
    /**
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @returns TranscriptionListResponse Ok
     * @throws ApiError
     */
    public static getTranscriptions(
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
    ): CancelablePromise<TranscriptionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/calls/transcriptions',
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns TranscriptionGetResponse Ok
     * @throws ApiError
     */
    public static getTranscription(
        id: number,
    ): CancelablePromise<TranscriptionGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/calls/transcriptions/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
}
